<template>
  <div>
    <p class="text-xs-center mt-5 headline">You have been invited to join</p>
    <p class="text-xs-center display-1" style="font-weight:bold;">{{school}}</p>
    <v-container fluid ma-0 pa-0>
      <v-layout justify-center align-center >
        <v-flex xs8 ma-5>
          <Panel title="Register" >
            <v-container fluid pa-5>
              <v-layout justify-center wrap>
                <form v-on:keyup.enter="register">
                    <v-layout justify-center align-start>
                      <v-flex>
                        <v-layout row wrap>
                          <v-flex xs12 mb-4>
                            <v-alert
                              :value="error"
                              type="error"
                              outline
                            >
                              {{ error }}
                            </v-alert>
                          </v-flex>
                          <v-flex xs12 my-1>
                            <v-text-field
                              outline
                              color="secondary"
                              label="Email Address"
                              v-model="username"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 my-1>
                            <v-text-field
                              outline
                              color="secondary"
                              label="Password"
                              type="password"
                              v-model="password"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 my-1>
                            <v-text-field
                              outline
                              color="secondary"
                              label="First Name"
                              v-model="firstname"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 my-1>
                            <v-text-field
                              outline
                              color="secondary"
                              label="Last Name"
                              v-model="lastname"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 text-xs-center>
                            <v-btn class="secondary ma-2"
                              color="#fff"
                              dark
                              @click="register">Register</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </form>
              </v-layout>
            </v-container>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Panel from '@/components/Panel'
import RedeemService from '@/services/RedeemService'

export default {
  data: function () {
    return {
      school: null,
      error: null,
      username: '',
      password: '',
      firstname: '',
      lastname: '',
      rules: {
          required: value => !!value || 'Required.'
      }
    }
  },
  components: {
    Panel
  },
  mounted: async function () {
    const code = this.$route.params.code;
    
    try {
      const result = await RedeemService.get(code)

      this.school = result.data.school
      
    } catch (err) {
      this.error = err.response.data.error;
    }
  },
  methods: {
    async register () {
      const code = this.$route.params.code;
      
      try {
        const response = await RedeemService.processJoinCodeForSignup({
          code: code,
          username: this.username,
          password: this.password,
          firstname: this.firstname,
          lastname: this.lastname,
          school: this.school
        })

        this.$store.dispatch('setToken', response.data.token);
        this.$store.dispatch('setUser', response.data.user);

        this.$router.push({
          path: '/'
        })
      } catch (err) {
        this.error = err.response.data.error;
      }
    }
  }
}
</script>

<style scoped>

</style>
